import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { mockCertificates, mockCertificateTypes } from '../services/mockDataService';
import styles from './CertificateDemo.module.css';

const CertificateDemo = () => {
  const [certificates, setCertificates] = useState(mockCertificates);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const handleViewDetails = (certificate) => {
    setSelectedCertificate(certificate);
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
    setSelectedCertificate(null);
  };

  const getCertificateTypeName = (typeId) => {
    return mockCertificateTypes[typeId] || 'Unknown Type';
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      active: styles.statusActive,
      expired: styles.statusExpired,
      archived: styles.statusArchived,
      'due_to_expire': styles.statusDueToExpire
    };

    return (
      <span className={`${styles.statusBadge} ${statusClasses[status] || styles.statusActive}`}>
        {status.replace('_', ' ').toUpperCase()}
      </span>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Property Certificate Management Demo</h1>
        <p>This demo showcases the certificate functionality copied from Laravel to React</p>
      </div>

      <div className={styles.navigation}>
        <Link to="/properties/2/certificate/create" className={styles.createButton}>
          <span className={styles.plusIcon}>+</span>
          Add New Certificate
        </Link>
        <Link to="/properties/2" className={styles.backButton}>
          ← Back to Property
        </Link>
      </div>

      <div className={styles.stats}>
        <div className={styles.statCard}>
          <h3>{certificates.length}</h3>
          <p>Total Certificates</p>
        </div>
        <div className={styles.statCard}>
          <h3>{certificates.filter(c => c.status === 'active').length}</h3>
          <p>Active Certificates</p>
        </div>
        <div className={styles.statCard}>
          <h3>{certificates.filter(c => c.status === 'expired').length}</h3>
          <p>Expired Certificates</p>
        </div>
      </div>

      <div className={styles.certificatesSection}>
        <h2>Property Certificates</h2>
        <div className={styles.certificatesGrid}>
          {certificates.map((certificate) => (
            <div key={certificate.id} className={styles.certificateCard}>
              <div className={styles.certificateHeader}>
                <h3>{certificate.name}</h3>
                {getStatusBadge(certificate.status)}
              </div>
              
              <div className={styles.certificateInfo}>
                <p><strong>Type:</strong> {getCertificateTypeName(certificate.document_type_id)}</p>
                <p><strong>Completed:</strong> {formatDate(certificate.date_completed)}</p>
                <p><strong>Expires:</strong> {formatDate(certificate.date_expiration)}</p>
                <p><strong>Contractor Date:</strong> {formatDate(certificate.date_contractor_appointment)}</p>
                <p><strong>Visible to Client:</strong> {certificate.visible_to_client ? 'Yes' : 'No'}</p>
              </div>

              <div className={styles.certificateActions}>
                <button 
                  className={styles.actionButton}
                  onClick={() => handleViewDetails(certificate)}
                >
                  View Details
                </button>
                <button className={styles.actionButton}>
                  Download
                </button>
                <button className={styles.actionButton}>
                  Edit
                </button>
                <button className={styles.actionButton}>
                  Archive
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Certificate Details Modal */}
      {showDetails && selectedCertificate && (
        <div className={styles.modalOverlay} onClick={handleCloseDetails}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h2>{selectedCertificate.name}</h2>
              <button className={styles.closeButton} onClick={handleCloseDetails}>
                ×
              </button>
            </div>
            
            <div className={styles.modalBody}>
              <div className={styles.detailRow}>
                <label>Certificate Type:</label>
                <span>{getCertificateTypeName(selectedCertificate.document_type_id)}</span>
              </div>
              
              <div className={styles.detailRow}>
                <label>Status:</label>
                <span>{getStatusBadge(selectedCertificate.status)}</span>
              </div>
              
              <div className={styles.detailRow}>
                <label>Date Completed:</label>
                <span>{formatDate(selectedCertificate.date_completed)}</span>
              </div>
              
              <div className={styles.detailRow}>
                <label>Date Expiration:</label>
                <span>{formatDate(selectedCertificate.date_expiration)}</span>
              </div>
              
              <div className={styles.detailRow}>
                <label>Contractor Appointment:</label>
                <span>{formatDate(selectedCertificate.date_contractor_appointment)}</span>
              </div>
              
              <div className={styles.detailRow}>
                <label>Visible to Client:</label>
                <span>{selectedCertificate.visible_to_client ? 'Yes' : 'No'}</span>
              </div>
              
              <div className={styles.detailRow}>
                <label>File URL:</label>
                <span>{selectedCertificate.file_url}</span>
              </div>
              
              <div className={styles.detailRow}>
                <label>Created:</label>
                <span>{formatDate(selectedCertificate.created_at)}</span>
              </div>
            </div>
            
            <div className={styles.modalFooter}>
              <button className={styles.modalButton} onClick={handleCloseDetails}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CertificateDemo; 